export default __webpack_public_path__ + "static/media/Iconupcomingsession.37afbaed.png";